import api from "../api";

export type ContactInfo = {
  address: string;
  city: string;
  created_at: string;
  email: string;
  hours: string;
  id: number;
  phone: string;
  updated_at: string;
  updated_by: string;
};

export type ContactSubmission = {
  email: string;
  message: string;
  name: string;
  recaptchaToken?: string;
  subject: string;
};

export type ContactSubmissionResponse = {
  message: string;
  submission: {
    created_at: string;
    email: string;
    id: number;
    message: string;
    name: string;
    subject: string;
    updated_at: string;
  };
  success: boolean;
};

export const ContactUsService = {
  async create(
    data: Omit<ContactInfo, "created_at" | "id" | "updated_at" | "updated_by">,
  ): Promise<ContactInfo> {
    const res = await api.post("/contact-info", data);
    return res.data.info;
  },

  async get(): Promise<ContactInfo> {
    const res = await api.get("/contact-info");
    // API returns { success, info, ... }
    return res.data.info;
  },

  async submitForm(
    data: ContactSubmission,
  ): Promise<ContactSubmissionResponse> {
    const res = await api.post("/contact-submit", data);
    return res.data;
  },

  async update(id: number, data: Partial<ContactInfo>): Promise<ContactInfo> {
    const res = await api.post(`/contact-info/${id}`, data);
    return res.data.info;
  },
};
